import gateway from '../gateway/gateway'
import { User } from '../types/user'
import { Person } from '../types/person'

export const getPersonByEmail = async (
  email: string,
  currentUser?: Pick<User, 'user_guid' | 'features'>
) => {
  const personData = await gateway.people.findByEmail(email)

  let detailedData: any = {}

  if (personData?.id) {
    try {
      const detailedPerson = await gateway.people.get(personData.id)
      detailedData = {
        active_success: detailedPerson.active_success,
        permissions: detailedPerson.permissions,
        starred: detailedPerson.starred,
        contact_restrictions: detailedPerson.contact_restrictions,
        company_object_id: detailedPerson.company_object_id ?? null,
        account_id: detailedPerson.account_id ?? null,
        owner_crm_name: detailedPerson.owner_crm_name ?? null,
        crm_id: detailedPerson.crm_id ?? null,
        score: detailedPerson.score,
      }
    } catch (error) {
      console.warn('Failed to fetch detailed person data:', error)
    }
  }

  if (currentUser?.features.outlook_public_api_people) {
    const query = {
      email_addresses: [email],
      sort_by: 'last_contacted_at',
    }

    const people = await gateway.publicPeople.get({
      ...query,
      owned_by_guid: currentUser?.user_guid,
    })

    if (people.length === 0) {
      const publicPeople = await gateway.publicPeople.get(query)
      return publicPeople.map((person: Person) => ({
        ...person,
        ...detailedData,
      }))
    }

    return people.map((person: Person) => ({
      ...person,
      ...detailedData,
    }))
  }

  return { ...personData, ...detailedData }
}

export const getPersonPauseWindow = async (personId: number) => {
  const people = await gateway.publicPeople.getPauseWindow(personId)
  return people?.data[0]
}
export const deletePerson = async (personId: number) => {
  const response = await gateway.people.deletePerson(personId)
  return response.data
}
export const getHotLeadDataPublic = async (personId: number) => {
  const response = await gateway.publicPeople.getHotLeadData(personId)
  return response.data
}
